import logo from './logo.svg';
import React from 'react';
import './App.css';
import MapComponent from './MapComponent';

function App() {
  return (
    <div className="App">
      <MapComponent />
    </div>
  );
}

export default App;
